import PropTypes from "prop-types";
import React from "react";

const CloudOutgoingIcon = props => {
  const { width, height, fill } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 120 80" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30 55
            C15 55 10 45 10 38
            C10 30 16 22 26 22
            C30 14 38 10 48 10
            C60 10 68 18 70 26
            C80 26 90 32 90 44
            C90 52 84 55 76 55
            H30"
        fill="#FFFFFF"
        stroke={fill}
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M60 45
            V28
            M52 36
            L60 28
            L68 36"
        stroke={fill}
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

CloudOutgoingIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fill: PropTypes.string,
};

CloudOutgoingIcon.defaultProps = {
  width: 18,
  height: 18,
  fill: "",
};

export default CloudOutgoingIcon;
